import React, {Component} from 'react';
import {connect} from "react-redux";

import {toggleFilter} from "../../actions/findActivities/filters/selected";

import Inputs from '../Inputs/index';

class FilterItem extends Component{
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    /**
     * filters[1]=2,3
     * @param e
     */
    handleChange(e) {
        const target    = e.target;
        const value     = target.value;
        this.props.toggleFilter(this.props.filter_group_id, value);
    }

    handleSelectChange(e) {
        const target    = e.target;
        const value     = target.value;
        this.props.toggleFilter(this.props.filter_group_id, value, false, 'select');
    }

    render() {
        const { filter_type, filter_values, filter_group_id } = this.props;
        let field = null;

        if (filter_group_id === 4) {
            filter_values.forEach(item => {
                switch(item.value) {
                    case 'activity':
                        Object.assign(item, {displayText: 'Move more'});
                        break;
                    case 'weight':
                        Object.assign(item, {displayText: 'Lose Weight'});
                        break;
                    case 'smoking':
                        Object.assign(item, {displayText: 'Stop Smoking'});
                        break;
                    case 'alcohol':
                        Object.assign(item, {displayText: 'Drink Less'});
                        break;
                }
            });
        }

        switch (filter_type) {

            case 'select' :
                field = filter_values.length && <Inputs
                    type="select"
                    params={{
                        value: filter_values[0].id,
                        options: filter_values,
                        filter_group_id : filter_group_id
                    }}
                    onChange={this.handleSelectChange}
                />

                break;
            case 'checkbox' :
                field = filter_values.length && <Inputs
                    type="checkboxgroup"
                    params={{ 
                        name: `filterGroup-${filter_group_id}`,
                        options: filter_values,
                        filter_group_id : filter_group_id,
                        pathwayImage: filter_group_id === 4,
                    }}
                    onChange={this.handleChange}
                />
                break;
        }
        return (
            field
        );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = dispatch => ({
    toggleFilter: (id, c, reset, filter_type) => {
        dispatch(toggleFilter(id,c,reset, filter_type));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterItem);
